import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MembershipService } from 'app/core/services/membership.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public membership: MembershipService, private router: Router) { }

  ngOnInit() {
    this.membership.GetSession().subscribe(
      data => {
        this.router.navigate(['/dashboard']);
      },
      error => {
        this.router.navigate(['/login']);
      });
  }

}
